
const INTRO_TEXT="Create a homework task that you can monitor.  This will create a link that you can share with your students.  When students open the link, they will be prompted to enter a name.  When they finish the game, their score will be recorded and all the records will be viewable here on this site.  Only you will be able to view this data.";

const CHINA_TEXT="Warning - Content and homework tasks may not be accessible for students in China.  The rest of the site and embedded pages should work.";

export const TasksHeader=function(){
	return(
		<>
			<h3>Homework Tasks</h3>
			<p>{INTRO_TEXT}</p>
			<p>{CHINA_TEXT}</p>
		</>
	);
}
